import { h } from 'preact';
import * as BaseComp from 'components/bolt/movieDetails/movieDetails.js';
import Store from 'store/store';
import Countdown from 'components/bolt/countdown/countdown';

export default class MovieDetails extends BaseComp.default {

	triggerButton(path, label) {
		setTimeout(() => super.updateBgStyle(), 100);
		super.triggerButton(path, label);
	}

	renderCountdown(countdown, position) {
		const clockData = Store.get().appData.options.countdownClock;
		if (clockData.location !== 'home') return;
		let { hide, visible } = this.props;
		const { targetDateTime, annotation, timeZone = '0' } = countdown;
		const appData = this.props.appData;
		const headerHeight = Store.get().client?.headerHeight || 0;

		return (
			<Countdown
				appData={appData}
				datetime={targetDateTime}
				timeOffset={timeZone}
				annotation={annotation}
				hidden={hide}
				visible={visible}
				position={position}
				headerHeight={headerHeight}
				showMilliseconds={clockData.showMilliseconds}
			/>
		);
	}
}